export default __webpack_public_path__ + "158f2e25e2c6b6cdda18d239151afb1e.svg";